import { SVGProps } from "react"

const PriceIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.47532 12.7492L7.25032 16.5242C8.80032 18.0742 11.317 18.0742 12.8753 16.5242L16.5337 12.8659C18.0837 11.3159 18.0837 8.79919 16.5337 7.24085L12.7503 3.47419C11.9587 2.68252 10.867 2.25752 9.75032 2.31585L5.58365 2.51585C3.91698 2.59085 2.59198 3.91585 2.50865 5.57419L2.30865 9.74085C2.25865 10.8659 2.68365 11.9575 3.47532 12.7492Z"
        stroke={props.color || "#0000FA"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91732 10.0007C9.06791 10.0007 10.0007 9.06791 10.0007 7.91732C10.0007 6.76672 9.06791 5.83398 7.91732 5.83398C6.76672 5.83398 5.83398 6.76672 5.83398 7.91732C5.83398 9.06791 6.76672 10.0007 7.91732 10.0007Z"
        stroke={props.color || "#0000FA"}
        strokeLinecap="round"
      />
    </svg>
  )
}
export default PriceIcon
